import { ResultListModel } from '@common-lib';

import { baseClient } from '../common';
import { OrderModel } from './order.model';
import { OrderInfoModel } from './order-info.model';
import { SearchOrderModel, SearchOrderPageModel } from './search-order.model';
import { TimeslotOrderGroupModel } from './timeslot-order-group.model';
import { UpdateOrderModel } from './update-order.model';

const apiUrl = `/api/orders`;

export const orderClient = {
  get: (orderId: string): Promise<OrderInfoModel> => {
    return baseClient.get<OrderInfoModel>(`${apiUrl}/${orderId}`);
  },

  list: (model: SearchOrderModel): Promise<OrderModel[]> => {
    return baseClient.body<SearchOrderModel, OrderModel[]>({
      body: model,
      method: 'POST',
      url: `${apiUrl}/search`,
    });
  },

  listPage: (
    model: SearchOrderPageModel,
  ): Promise<ResultListModel<OrderModel>> => {
    return baseClient.body<SearchOrderPageModel, ResultListModel<OrderModel>>({
      body: model,
      method: 'POST',
      url: `${apiUrl}/search/page`,
    });
  },

  listTimeslot: (
    model: SearchOrderModel,
  ): Promise<TimeslotOrderGroupModel[]> => {
    return baseClient.body<SearchOrderModel, TimeslotOrderGroupModel[]>({
      body: model,
      method: 'POST',
      url: `${apiUrl}/search/timeslot`,
    });
  },

  update: (orderId: string, model: UpdateOrderModel): Promise<OrderModel> => {
    return baseClient.body<UpdateOrderModel, OrderModel>({
      body: model,
      method: 'PUT',
      url: `${apiUrl}/${orderId}`,
    });
  },
};
